import { PortalPageFrame } from "../common"
import { Uploader } from "../features"

const UploaderPage = () =>
  <PortalPageFrame title="Model Uploader">
    <Uploader />
  </PortalPageFrame>

export default UploaderPage
